import { Handle, Position, type NodeProps } from "@xyflow/react";
import { Box, Chip, Typography } from "@mui/material";
import StorageOutlinedIcon from "@mui/icons-material/StorageOutlined";
import type { PrepFlowNodeData } from "../../utils/graphAdapter";
import { useAppCustomStyles } from "../../../../assets/theme/custom/hooks";

export default function PrepDslQueryNode({ data }: NodeProps) {
  const flowData = data as PrepFlowNodeData;
  const custom = useAppCustomStyles();
  const node = flowData.graphNode;
  return (
    <Box
      sx={custom.components.dataPrep.dslQueryNode({ stale: flowData.stale, error: flowData.error, tested: flowData.tested })}
    >
      <Handle type="target" position={Position.Left} />
      <Box sx={custom.components.dataPrep.flowNodeTitleRow}>
        <StorageOutlinedIcon fontSize="small" color="primary" />
        <Typography variant="subtitle2" fontWeight={600}>
          {node.label || "DSL Query"}
        </Typography>
      </Box>
      <Typography variant="caption" color="text.secondary" sx={custom.components.dataPrep.flowNodeCaption}>
        {node.sourceIndex || "— index —"}
      </Typography>
      {flowData.stale && <Chip size="small" label="Stale" color="warning" sx={custom.components.dataPrep.dslQueryNodeChipWithMargin} />}
      {flowData.tested && !flowData.stale && <Chip size="small" label="Tested" color="success" sx={custom.components.dataPrep.dslQueryNodeChip} />}
      {flowData.error && <Chip size="small" label="Error" color="error" sx={custom.components.dataPrep.dslQueryNodeChip} />}
      <Handle type="source" position={Position.Right} />
    </Box>
  );
}
